/*
* Copyright (c) 2019 Honeywell International, Inc. All rights reserved.
*
* This file contains trade secrets of Honeywell International, Inc.  No part
*  may be reproduced or transmitted in any form by any means or for any
*  purpose without the express written permission of Honeywell.
*
*/
import { Component, OnInit } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';
import { RawDataDiscoveryService } from '../../app/fsl/services/raw-data-discovery/raw-data-discovery.service';
import { EventBusService } from '../../app/fsl/services/shared/event-bus.service';
import { ViewChild } from '@angular/core';
import { SiteInfoService } from '../../context-discovery-services/services/site-info.service';


@Component({
  selector: 'adminapp-raw-data-discovery-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {
  isContextDiscoveryInProgress: boolean;
  showNotFoundError: boolean;
  showAuthenticationError: boolean;
  showGenericError: boolean;
  organizationId: string;
  systemGUID: string;
  isAssetDiscoveryInitiated: boolean;
  isStartButtonEnabled: boolean;
  contextDiscoveryStatus: string;
  isSystemGUIDPresent: boolean;

  @ViewChild('startDiscoveryButton') startDiscoveryButton: any;

  constructor(private eventBus: EventBusService, private ref: ChangeDetectorRef,
    private rawDataDiscoveryService: RawDataDiscoveryService,
    private siteInfoService: SiteInfoService) {
    this.organizationId = sessionStorage.getItem('organizationid');
    this.isSystemGUIDPresent = false;
    this.isStartButtonEnabled = false;
    this.eventBus.serverError$.subscribe((errorMessage) => {
      const identifyAssetsErrorToast: any = document.getElementById('identifyAssetsErrorToast');
      identifyAssetsErrorToast.text = errorMessage;
      identifyAssetsErrorToast.open();
    });
  }

  ngOnInit() {
    this.initializeView();
  }

  removeAllErrors() {
    this.showGenericError = false;
    this.showAuthenticationError = false;
    this.showNotFoundError = false;
  }

  resetStatusTrackers() {
    this.isContextDiscoveryInProgress = false;
  }

  initializeView() {
    this.removeAllErrors();
    this.resetStatusTrackers();
    this.systemGUID = this.siteInfoService.getSystemGuid();
    if (this.systemGUID) {
      this.isSystemGUIDPresent = true;
      this.enableDisableStartButton(true);
    }
  }

  enableDisableStartButton(flag: boolean) {
    this.isStartButtonEnabled = flag;
  }

  startRawDataDiscovery() {
    this.removeAllErrors();
    this.isAssetDiscoveryInitiated = false;
    this.isContextDiscoveryInProgress = true;

    this.rawDataDiscoveryService.triggerAssetDiscovery(this.systemGUID).subscribe(() => {
      this.isAssetDiscoveryInitiated = true;
      this.isContextDiscoveryInProgress = false;
    }, this.handleFailure.bind(this));

  }

  isCdtOperationOngoing() {
    return this.isContextDiscoveryInProgress;
  }

  isAnyErrorOccurred() {
    return this.showAuthenticationError || this.showNotFoundError || this.showGenericError;
  }

  canLayoutBeHidden() {
    return false;
  }

  handleFailure(errorResponse) {
    this.removeAllErrors();
    this.enableDisableStartButton(true);
    switch (errorResponse.status) {
      case 401:
        this.showAuthenticationError = true;
        break;
      case 404:
        this.showNotFoundError = true;
        break;
      default:
        this.showGenericError = true;
    }
    this.ref.detectChanges();
  }

}
